module.exports = __webpack_public_path__ + "img/esg_energycost.e853ac07.svg";